<template>
    <div v-show="visible">
        <el-dialog title="添加学校" 
            v-loading="loading"
            element-loading-background = "rgba(255, 255,255,0.7)"
            element-loading-text = "添加学校中，请耐心等待..."
            :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="380px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item   prop="name" label="学校名称">
                    <el-input v-model="form.name" maxlength="200" style="width: 200px;"></el-input>
                </el-form-item>

                <el-form-item   prop="nature" label="学校性质">
                    <el-select v-model="form.nature" clearable placeholder="请选择" style="width: 200px;">
                        <el-option
                            v-for="item in natures"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item   prop="orderNum" label="排序号">
                    <el-input v-model="form.orderNum" maxlength="200" type="number" style="width: 200px;"></el-input>
                </el-form-item>
            
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" @click="save()">确定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                loading: false,
                form:{
                    name:"",
                    nature:"",
                    orderNum:1
                },
                natures: [{
                    value: 1,
                    label: '幼儿园'
                }, {
                    value: 2,
                    label: '小学'
                }, {
                    value: 3,
                    label: '中学'
                }],
                rules: {
                    name: [
                        { required: true, message: '请输入学校名称', trigger: 'blur' }
                    ],
                    nature: [
                        { required: true, message: '请选择学校性质', trigger: 'blur' }
                    ]
                }
            }
        },
        components: {
        },
        created:function () {
        },
        methods:{
            init(){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.loading = false;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.deptAddSchoolUrl;
                        let data = {
                            name:this.form.name,
                            nature: this.form.nature,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        this.loading = true;
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status == 200){
                                this.$commonFn.showTip(res.message,1);
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.visible=false;
                        }, (err) => {
                            console.log(err);
                            this.visible=false;
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/sys/dept/addSchool.vue